<template>
  <div>
    <div class="panel">
      <div class="panel_titulo"> <h1> Gestión del Geoportal  </h1></div>
       
      <div class="panel_campos">
         
        <!-- <router-link  
              class="campo" 
              v-bind:to="'/gestion/formulario'">
              <img class="campo_icono" src="../assets/img/usuarios.svg"/>Usuarios
        </router-link>  -->

       

        <router-link  
              class="campo" 
               v-bind:to="'/gestion/formulario'">
               <img class="campo_icono" src="../assets/img/edificio.svg"/>Edificios
        </router-link>

        <router-link  
              class="campo" 
               v-bind:to="'/gestion/formularioArea'">
              <img class="campo_icono" src="../assets/img/area.svg"/>U. Administrativas y Académicas
        </router-link> 
        <router-link  
              class="campo" 
               v-bind:to="'/gestion/formularioArea'">
              <img class="campo_icono" src="../assets/img/usu.svg"/>Usuarios
        </router-link> 
          <router-link  
              class="campo" 
              v-bind:to="'/gestion/formularioVisitante'">
             
              <img class="campo_icono" src="../assets/img/publico.svg"/>Visitantes
        </router-link> 
      </div>

        <router-link  
              class="atras " 
              v-bind:to="'/aplicacion/1'">
              <img class="campo_icono" src="../assets/img/atras.svg"/>
        </router-link> 


    </div>
  </div>
</template>
<script>

export default {
  name: 'panel',
  data: function(){
    return {
      login: true,
    }
  },
  components: {
  },
 
 /* beforeRouteEnter (to, from, next) { 
     if (this.$store.state.login) {
        next()
      } else {
        next(false)
      }
  } */
}
</script>
</script>
<style  lang="scss"  scoped src="../sass/panel.scss"></style>



// WEBPACK FOOTER //
// src/components/panel.vue